import React from "react";
import tagToWord from "../../../utils/tagToWord";
import Link from "../../../utils/link";
import { useStaticQuery, graphql } from "gatsby"

const ScopeHeader = (props) => {

    const tagList = props.tagList

    // limit to 4 tags

    const data = useStaticQuery(graphql`
    {
        filters: allStoryblokDatasourceEntry(
            filter: {parent: {}, data_source: {glob: "type-of-work-projects"}}
          ) {
            edges {
              node {
                id
                value
                name
                data_source
              }
            }
          }
        
      }
      
  `)

  // extract the filters from the query and generate a list of .value's

    const filters = data.filters.edges.map((filter) => {
        return filter.node.value
    })

    // generate a tag list that can be a maximum of 4 tags. the tag must be in the filters list

    const limitedTags = tagList.filter((tag) => {
        return filters.includes(tag)
    }).slice(0, 4)

    const tagMap = data.filters.edges.reduce((acc, filter) => {
        acc[filter.node.value] = filter.node.name
        return acc
    }, {})

    return (
        <nav className={`absolute line-under-nav-height width pt-5 lg:pt-3 text-xs lg:text-base flex lg:gap-x-6 gap-x-1 z-10 ${props.navStyle == "white-black" ? `lg:text-white` : ``}`}>
            <span className="lg:font-semibold">Project Scope: </span><ol className="space-x-1 lg:space-x-6">
                {
                    limitedTags.map((tag, index) => {
                        return (
                            <li key={`scope-header-${index}`} className={`inline-block`}>
                                <Link to={`/work/?tag=${tag}`} className='hover-underline-animation'>{tagMap[tag] || tagToWord(tag)}<span className="lg:hidden">{index < limitedTags.length - 1 && (', ')}</span></Link>
                            </li>
                        )
                    })
                }
            </ol>
        </nav>
    )
}

export default ScopeHeader;